var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBodycodiPlusService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H42C48.6274 0 54 5.37258 54 12V42C54 48.6274 48.6274 54 42 54H12C5.37258 54 0 48.6274 0 42V12Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2219 21.1686L30.2223 21.1676C28.8765 20.6857 27.4189 20.3998 25.8943 20.3998C23.5901 20.3998 21.4398 21.0194 19.5775 22.0816V32.9244C19.5775 29.4724 22.4032 26.6695 25.8943 26.6695C26.6541 26.6695 27.3846 26.8136 28.055 27.0595L28.0551 27.0591C30.4779 27.9347 32.2105 30.2259 32.2105 32.93C32.2105 36.382 29.3848 39.185 25.8937 39.185C22.4026 39.185 19.577 36.3869 19.577 32.93V22.0822V17.4402C19.577 15.7093 18.1567 14.3029 16.4087 14.3029C14.6606 14.3029 13.2404 15.7093 13.2404 17.4402V32.9251C13.2404 39.8439 18.9016 45.4497 25.8888 45.4497C32.8759 45.4497 38.5471 39.8439 38.5471 32.9251C38.5471 27.5121 35.0722 22.92 30.2219 21.1686Z",
    fill: "#19143C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2195 20.4022H37.3664C37.0522 20.4022 36.7974 20.1474 36.7974 19.8331V15.9138H32.8788C32.5646 15.9138 32.3098 15.6591 32.3098 15.3448L32.3098 13.4917C32.3098 13.1774 32.5646 12.9227 32.8788 12.9227H36.7974V9.00653C36.7974 8.69226 37.0522 8.4375 37.3664 8.4375H39.2195C39.5338 8.4375 39.7886 8.69226 39.7886 9.00653V12.9227H43.7055C44.0197 12.9227 44.2745 13.1774 44.2745 13.4917V15.3448C44.2745 15.6591 44.0197 15.9138 43.7055 15.9138H39.7886V19.8331C39.7886 20.1474 39.5338 20.4022 39.2195 20.4022Z",
    fill: "#F83C77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodycodiPlusService);
export default __webpack_public_path__ + "static/media/bodycodi_plus_service.1f3028ccf80304a7e5ac53c1a061e86f.svg";
export { ForwardRef as ReactComponent };